import React from "react";
import "./CompanyAndSharesResult.css";
import { Text, View, Link, Image } from "@react-pdf/renderer";
import { styles } from "../styles/Slide11Styles";
import logoNavigating from "../img/logoNavigating.png";

export function Slide11() {
  const today = new Date();
  return (
    <View>
      <View style={styles.containerCenter}>
        <Image style={styles.logo} src={logoNavigating}></Image>
      </View>
      <View style={styles.containerLeftBottom}>
        <Text style={styles.text}>{today.getFullYear()} mace</Text>
        <Text style={styles.text}>© All Rights Reserved</Text>
        <Link src={"www.mace-legal.com"}>
          <Text style={styles.text}>www.mace-legal.com</Text>
        </Link>
      </View>
      <View style={styles.containerRightBottom}>
        <Text style={styles.text}>
          This report is confidential and may not be distributed.
        </Text>
      </View>
    </View>
  );
}
